// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'custom-column';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.978 1H1.001v13.867h4.977zM1 5.622h4.977M1 10.245h4.977m10.596.782L11.17 16.43 8.467 17l.569-2.702 5.404-5.404c.57-.57 1.564-.57 2.133 0 .57.64.57 1.564 0 2.133z'
  />
);

export const viewBox = '0 0 18 18';
